import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5e1766c5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "item-secondary-title pt-2" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 0,
  class: "item-secondary-title pt-2"
}
const _hoisted_4 = { class: "mb-4" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-duration" }, " An email has been sent to the insured to accept the terms and authorise the direct debit. ", -1))
const _hoisted_7 = { class: "text-blue" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-duration" }, " Steps should be completed as soon as possible, as cover won't start until accepted, and late authorization may affect direct debit dates. ", -1))
const _hoisted_9 = { key: 1 }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-duration" }, "An email has been sent to the insured to accept the terms.", -1))
const _hoisted_11 = { class: "text-blue" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-duration" }, " Steps should be completed as soon as possible, as cover won't start until accepted. ", -1))
const _hoisted_13 = {
  key: 1,
  class: "item-secondary-title pt-2"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-duration" }, " Thank you for completing all the details. You will be notified once the application has been assessed. ", -1))
const _hoisted_15 = [
  _hoisted_14
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("p", _hoisted_1, [
      _createTextVNode(" Almost done"),
      (!_ctx.isPolicyReferred)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, ". Next steps:"))
        : _createCommentVNode("", true)
    ]),
    (!_ctx.isPolicyReferred)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("p", _hoisted_4, [
            (_ctx.policyInfo.policy.paymentConfigurations[0].method == 'Direct debit')
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                  _hoisted_6,
                  _createElementVNode("p", _hoisted_7, " Please share the Policy ID " + _toDisplayString(_ctx.policyNumber) + " with them for identity verification in the email. ", 1),
                  _hoisted_8
                ]))
              : (_openBlock(), _createElementBlock("span", _hoisted_9, [
                  _hoisted_10,
                  _createElementVNode("p", _hoisted_11, " Please share the Policy ID " + _toDisplayString(_ctx.policyNumber) + " with them for identity verification in the email. ", 1),
                  _hoisted_12
                ]))
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isPolicyReferred)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_15))
      : _createCommentVNode("", true)
  ]))
}